import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const features = [
    {
      title: 'Analyse de CV',
      description: 'Un score sur 100 et des points d’amélioration identifiés par section.',
    },
    {
      title: 'Compatibilité ATS',
      description: 'Des conseils pour passer les filtres automatiques des recruteurs.',
    },
    {
      title: 'Conseils concrets',
      description: 'Des suggestions exploitables, adaptées à votre secteur.',
    },
    {
      title: 'Génération de CV',
      description: 'Des templates pensés pour rester lisibles par un ATS.',
    },
  ];

  return (
    <div className="min-h-screen bg-slate-200 pt-16">
      <div className="bg-slate-900 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl md:text-4xl font-semibold mb-3">
            À propos de CV Analyse
          </h1>
          <p className="text-slate-300 max-w-2xl leading-relaxed">
            Un outil pour analyser votre CV, obtenir un score et des conseils concrets.
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 space-y-8">
        <section className="card-surface p-6 sm:p-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-3">Notre mission</h2>
          <p className="text-slate-600 leading-relaxed">
            Simplifier votre recherche d&apos;emploi en rendant votre CV plus lisible pour un recruteur
            et pour un ATS. Chaque candidat mérite d&apos;être lu.
          </p>
        </section>

        <section className="card-surface p-6 sm:p-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-3">Qui sommes-nous ?</h2>
          <p className="text-slate-600 mb-4 leading-relaxed">
            CV Analyse est édité par Guillaume Colin, entrepreneur individuel.
            L&apos;outil est conçu pour rester simple et utile, sans surplus marketing.
          </p>
          <p className="text-slate-600 leading-relaxed">
            Notre approche : des retours clairs, des données protégées, et un essai sans carte bancaire.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">Ce que vous pouvez faire</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {features.map((feature) => (
              <div key={feature.title} className="card-surface p-5">
                <h3 className="font-semibold text-slate-900 mb-1">{feature.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-band text-center">
          <h2 className="text-xl font-semibold mb-2">Prêt à analyser votre CV ?</h2>
          <p className="text-slate-300 text-sm mb-5">
            Score et 3 conseils offerts — rapport complet dès 5 €.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="btn-primary">
              Voir mon score
            </Link>
            <Link to="/" className="btn-secondary">
              Voir l&apos;accueil
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
